<script lang="ts">
  // This is a fake button. It looks like a standard button, but wrapped in a div. All of the
  // classes were copied from the Button element, and many removed.
  let { children } = $props();
</script>

<div
  class="border-input bg-background ring-offset-background focus-visible:ring-ring pointer-events-none inline-flex h-10 w-full items-start gap-2 rounded-md border px-4 py-2 text-left text-sm font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0"
>
  {@render children?.()}
</div>
